import { WEBSITE_URL } from '@/constants/common';
import ArticleSchema from './ArticleSchema';
import VideoSchema from './VideoSchema';
interface Props {
  contentUrl: string;
  createdAt: string;
  description: string;
  imagesList: string[];
  name: string;
  updatedAt: string;
  userFullName: string;
  videoLink?: string;
}
const ContentLDSchema = ({
  contentUrl,
  createdAt,
  description,
  imagesList,
  name,
  updatedAt,
  userFullName,
  videoLink
}: Props) => <>
    <ArticleSchema id={`${WEBSITE_URL}/${contentUrl}`} headline={name} description={description} imagesList={imagesList} createdAt={createdAt} updatedAt={updatedAt} userFullName={userFullName} data-sentry-element="ArticleSchema" data-sentry-source-file="ContentLDSchema.tsx" />
    {videoLink ? <VideoSchema name={name} description={description} videoLink={videoLink} createdAt={createdAt} contentUrl={`${WEBSITE_URL}/${contentUrl}`} userFullName={userFullName} /> : null}
  </>;
export default ContentLDSchema;